import { FactoryProvider } from '@angular/core';
import { WINDOW } from './window.token';

export function windowFactory(): Window {
  return typeof window !== 'undefined' ? window : ({} as Window);
}

export const WINDOW_PROVIDER: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
};
